/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkAssessmentRunCreateRequest {
    getFixupPrototypeFunction() { return WellArchitectedFrameworkAssessmentRunCreateRequest.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkAssessmentRunCreateRequest>): WellArchitectedFrameworkAssessmentRunCreateRequest {
        let obj = Object.assign(new WellArchitectedFrameworkAssessmentRunCreateRequest(), model);
        WellArchitectedFrameworkAssessmentRunCreateRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkAssessmentRunCreateRequest>): WellArchitectedFrameworkAssessmentRunCreateRequest {
        if (!model) return null;
        return WellArchitectedFrameworkAssessmentRunCreateRequest.newInstance(<WellArchitectedFrameworkAssessmentRunCreateRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkAssessmentRunCreateRequest) {
        if (!obj) return;

        models.WellArchitectedFrameworkAssessmentRunCreateRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkAssessmentRunCreateRequest): boolean {
        Object.setPrototypeOf(obj, WellArchitectedFrameworkAssessmentRunCreateRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.assessment_version) {
            models.RecordIdentity.fixupPrototype(this.assessment_version);
        }
        if (this.workload_version) {
            models.RecordIdentity.fixupPrototype(this.workload_version);
        }
    }

    /**
     * The version of the Assessment used for this run
     */
    assessment_version: models.RecordIdentity;

    /**
     * The version of the Workload used for this run
     */
    workload_version: models.RecordIdentity;

}
